<template>
    <div class="ve-list-page">
        <split-pane class="ve-list-page__body" :min-percent='10' :default-percent='12' split="vertical" v-if="spFlag">
            <template slot="paneL">
                <el-tree :data="accData" 
                            :props="defaultProps" 
                            @node-click="handleNodeClick" 
                            node-key="id"                       
                            :style="{height: scrollerHeight,overflow:'auto',display: 'flex',padding:15}"
                            highlight-current
                            :filter-node-method="filterNode"
                            ref="eltree"
                            :default-expanded-keys="expkeys" 
                            :expand-on-click-node="false">
                    <template v-slot="{node,data}">                                     
                        <span v-if="data.id ==0 "  class="nodeRoot" >
                        
                        <span  style="font-size:14px;color:#409efe">{{ node.label}}<i class="iconfont icon-zhanghuyue" style="color:#409eff;font-size:16px;"></i> </span>
                        </span>                  
                        <span v-else > 
                            <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="color:#409eff;font-size:14px;"></i> {{ node.label}} </span>
                        </span>
                    </template>
                </el-tree>
            </template>  
            <template slot="paneR">
                <div class="ve-list-page ve-list-page--embedded">
                <div style="display:flex;line-height:25px ;  "> 
                    <div  class="oneMenu" @click="itemClick('one')">
                        <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                            <i class="iconfont icon-huizong" style="margin-left:4px;margin-right:5px"></i>日记账-汇总</div> 
                    </div>
                    <div  class="oneMenu" @click="itemClick('two')">
                        <div style="margin-left:40px" :class="{active: actitem==='two'}" >
                            <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>日记账-明细</div> 
                    </div>
                </div> 
                <div v-show="actitem=='two'" class="ve-list-page__body">
                    <list-item></list-item>
                </div>        
                <div v-show="actitem=='one'" style="display:flex;padding-top:3px;width:2000px;background:#fff;line-height:30px;height:40px ;border-bottom:2px solid #389;  ">
                    <div style="width:70px">
                        <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                        <el-link :disabled="addBool"  @click="addRec" :underline="false" ><span style="font-size:12px;margin-right:15px;font-weight:600">新增 </span></el-link>
                    </div>
                    <span style=" font-size:12px;margin-right:10px;">字段查询</span>
                    <el-select v-model="selparam"  placeholder="请选择列名" filterable  size="small" style="width:130px; ">
                        <span v-for="item in tabArr.filter(item=>item.thide=='N')" :key='item.key'>
                            <el-option :label="item.title" :value="item.key" style="width:150px;"></el-option>
                        </span>
                    </el-select>
                    <el-input placeholder="请输入查询值" v-model="txtparam" size="small" style="width:250px; height:30px;  ">
                        <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                        <div slot="prepend">
                            <el-select v-model="oper"  size="small" style="width:100px;" >
                                <span v-for="item in operArr" :key='item.IDSEQ'>
                                    <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                                </span>
                            </el-select>
                        </div>
                    </el-input>
  
                    <el-button @click="freshCalc"  size="mini" type="primary" style=" height:30px;margin-left:10px;fon-size:11px "><i class= "iconfont icon-xitongguanli"></i>余额计算</el-button>
                    <el-button @click="showCalc" icon="iconfont icon-tishi" size="mini"  type="info" style=" height:30px;margin-left:20px;  ">显示余额</el-button>
 
                    <el-button type="danger"   icon="iconfont icon-daochu" @click="expExcel" size="mini" style="margin-left:25px;height:30px;margin-top:1px">导出当前资料</el-button>
                </div>
                <el-table v-show="actitem=='one'" :data="tabData"
                        border                            
                        disabled-hover
                        class="custom-table-border"
                        style="overflow:auto;margin-top:1px;"
                        size="small"
                        header-cell-class-name="clearPadding"
                        :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                        :height="sumHeight" 
                        :row-key="getRowKey"  
                        show-summary
                        :summary-method="getDtlSum"
                        ref="tabref" 
                        @row-click="rowClick"
                        highlight-current-row>
                    <el-table-column label="序号" type="index" width="60" fixed align="center">
                        <el-table-column label="序号" type="index" width="60" fixed align="center">
                            <template slot="header"  >
                                <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                                    <el-tooltip content=" 清除条件" effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column  v-for="(item,index ) in tabArr.filter(item=>item.thide=='N')" :key="index" 
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                        :min-width="item.width">
                        <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align"  show-overflow-tooltip :min-width="item.width">
                            <template slot="header" slot-scope="scope">
                                {{scope.row}}
                                <el-select v-if="item.key=='STFG'" @change="qryTabData" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                                    <el-option label="已审" value="Y"  ></el-option>
                                    <el-option label="未审" value="N"  ></el-option>
                                </el-select>
                                <el-select v-else-if="item.key=='WORDNM'" @change="qryTabData" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                                    <el-option label="收" value="收"  ></el-option>
                                    <el-option label="付" value="付"  ></el-option>
                                </el-select>
                                <el-date-picker v-else-if="item.edcss=='date'" @change="qryTabData" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                                <el-input type="number" placeholder="数字框"  @keyup.enter.native="qryTabData" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                                <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="qryTabData"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                            </template>
                            <template   slot-scope="scope" >
                                <el-tag  v-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark"  >是</el-tag>
                                <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']!=='Y'" size="mini" type="info" effect="dark">否</el-tag>
                                <el-checkbox v-else-if="item.edcss==='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" ></el-checkbox>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="210">
                        <template slot-scope="scope">                        
                            <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link   @click="editRec(scope.row,scope.$index,'Y')" :underline="false"  ><span style="font-size:11px;margin-right:5px;">查看</span></el-link>              
                            <span v-if="scope.row.STFG!=='Y'">
                                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link :disabled="editBool" @click="editRec(scope.row,scope.$index,'N')" :underline="false"  ><span style="font-size:11px;margin-right:5px;">编辑 </span></el-link>
                            </span>
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="delBool" @click="recSet(scope.row,'X',scope.$index)" :underline="false"  ><span style="font-size:11px;margin-right:5px;">作废</span></el-link>
                            <span v-if="scope.row.STFG!=='Y'">
                                <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link :disabled="cfmBool" @click="recSet(scope.row,'Y',scope.$index)" :underline="false"  ><span style="font-size:11px;margin-right:5px;">审核 </span></el-link>
                            </span>
                            <span v-if="scope.row.STFG==='Y'">
                                <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link :disabled="cfmBool" @click="recSet(scope.row,'N',scope.$index)" :underline="false"  ><span style="font-size:11px;margin-right:3px;">弃审</span></el-link>
                            </span>
                        </template>
                    </el-table-column>                      
                </el-table> 
                <div v-show="actitem=='one'" style="line-height:30px;height:35px; overflow: hidden;display:flex;margin-top:5px;font-size:12px">
                    <div style="float: left;padding-left:6px">
                        <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                    </div>
                    <div style="color:#606266; font-size:12px;width:35px;margin-left:10px ;">每页</div>
                    <el-select v-model="rowSize" size="small" style="width:80px;margin-right:10px ;"  @change="initPage">
                        <el-option 
                            v-for="item in pageList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                    <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                    <span style="color:#606266;margin-left:10px ;font-size:12px;">页</span>
                    <el-button @click="goNext" size="small" type="primary" style="width:50px;margin-left:15px;height:32px;">GO</el-button>
                </div> 
                </div>
            </template>  
        </split-pane> 
 
        <!-- 选择科目 -->
        <el-dialog :visible.sync="subWin" width="1100px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">收支类别</span>
            </div> 
            <div style="height:90vh;overflow-y:auto"><subject @child-sure="subOk"></subject></div>
        </el-dialog>
        <!-- 往来单位  -->
        <el-dialog :visible.sync="corpWin" width="1000px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">往来单位</span>
            </div> 
            <custSup @child-clnt="clntSel" @child-sup="supSel"></custSup>
        </el-dialog>
        <el-dialog :show-close="false" class="pub_dialog" v-dialogDrag :visible.sync="addWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
            <Form ref="addForm" :model="formCol" :label-width="120"  :rules="ruleValidate"  label-position="right" inline >
                <span v-for="(item,index) in tabArr" :key="index" >
                    <FormItem class="item-width"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                        <el-input size="small" :placeholder="item.holder" :disabled="saveFlag" v-enter-number  v-if="item.edcss==='number'" v-model="formCol[item.key]" style="width:100%" ></el-input>   
                        <el-checkbox size="small" :disabled="saveFlag" border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formCol[item.key]" style="width:100%"></el-checkbox> 
                        <el-date-picker size="small" :disabled="saveFlag" type="datetime"  v-else-if="item.edcss==='date'" v-model="formCol[item.key]" clearable value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" ></el-date-picker>     
                        <el-select size="small" :disabled="saveFlag" v-else-if="item.key==='CASHNO'" v-model="formCol[item.key]" style="width:100%" >
                            <span v-for="(item ,index) in cashArr" :key='index'>
                                <el-option :label="item.ACCNM" :value="item.IDSEQ" ></el-option>
                            </span>
                        </el-select>
                        <el-select size="small" :disabled="saveFlag" v-else-if="item.key==='PAYMTH'" v-model="formCol[item.key]" style="width:100%" >
                            <span v-for="(item ,index) in payArr" :key='index'>
                                <el-option :label="item.CNAME" :value="item.CODE" ></el-option>
                            </span>
                        </el-select>   
                        <el-select size="small" @change="wordChange" :disabled="saveFlag" v-else-if="item.key==='WORD'" v-model="formCol[item.key]" style="width:100%" >
                            <span v-for="(item ,index) in certArr" :key='index'>
                                <el-option :label="item.CNAME" :value="item.CODE" ></el-option>
                            </span>
                        </el-select>  
                        <el-input size="small" type="text" v-else-if="item.key==='ORIENT'" disabled v-model="formCol[item.key]">
                            <div slot="append">
                                <el-tooltip content="指示余额的方向： 余额大于0为借、小于0方向为贷、等于0为平" placement="bottom" effect="light">
                                    <el-button icon="iconfont icon-wenhaoxiao" style="width:50px;color:red"></el-button>
                                </el-tooltip>
                            </div>
                        </el-input>
                        <el-select size="small" @change="empChg" filterable :disabled="saveFlag" v-else-if="item.key==='EMPNO'" v-model="formCol[item.key]" style="width:100%" >
                            <span v-for="(item ,index) in empArr" :key='index'>
                                <el-option :label="item.EMPNM" :value="item.IDNO" ></el-option>
                            </span>
                        </el-select> 
                        <el-select size="small" filterable @change="orgChg" v-else-if="item.key==='ORGNM' " v-model="formCol[item.key]"   style="width:100%">
                            <el-row v-for="(item ,index) in orgArr " :key="index"> 
                                <el-col :span="4">
                                    <el-option  :label="item.TY" :value="item.EMPNM"></el-option>
                                </el-col>
                                <el-col :span="10">
                                    <el-option  :label="item.DEPTNM" :value="item.EMPNM"></el-option>
                                </el-col>
                                <el-col :span="10">
                                    <el-option  :label="item.EMPNM" :value="item.EMPNM"></el-option>
                                </el-col>
                            </el-row>
                        </el-select>
 
                        <el-select size="small" @change="acChg" filterable :disabled="saveFlag" v-else-if="item.key==='ACNO'" v-model="formCol[item.key]" style="width:100%" >
                            <span v-for="(item ,index) in acArr" :key='index'>
                                <el-option :label="item.CNAME" :value="item.IDSEQ" ></el-option>
                            </span>
                        </el-select> 
 
                        <el-input-number size="small" :precision="item.dotnum" style="width:100%" v-else-if="item.key=='BAMT'"  :disabled="bFlag||saveFlag" :class="bFlag?'yellow':''"  v-model="formCol[item.key]"></el-input-number>
                        <el-input-number  size="small" :precision="item.dotnum" style="width:100%"  v-else-if="item.key=='DAMT'"  :disabled="aFlag||saveFlag" :class="aFlag?'yellow':''" v-model="formCol[item.key]"></el-input-number>
                        
                        <el-input size="small" :placeholder="item.holder" type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag"  v-model="formCol[item.key]"></el-input>
                        <span slot="label" v-if="item.key==='DAMT'"><span style="color:red">{{item.title}}</span></span>
                        <span slot="label" v-else-if="item.key==='BAMT'"><span style="color:green">{{item.title}}</span></span>
                    </FormItem>
                </span>    
            </Form>   
            <div style="line-height:30px;border:1px solid #ccc;margin-bottom:6px; ">
                <el-button  class="button-new-tag" icon="iconfont icon-xinzeng" size="mini" type="text" plain @click="showInput">新增标签</el-button>
                <el-tag :key="index" v-for="(item,index) in tagArr" closable @close="tagClose(item)">{{item}}</el-tag>
                <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm">
                </el-input>  
            </div>
            <!-- 关联费用 -->
            <div class="one-toolbar">
                <span class="spanRow">关联费用明细</span> 
                <i class="iconfont icon-xinzeng" style="color:white;font-size:14px;margin-right:5px;margin-left:38px;"></i>
                <el-link :disabled="addBool"  @click="addList" :underline="false" ><span style="font-size:12px;margin-right:15px;color:white">新增记录</span></el-link>
            </div>
            <el-table  :data="feeData" 
                border                            
                disabled-hover
                :cell-style="{padding:'2px'}"
                style="overflow:auto;margin-top:1px;"
                size="small"
                class="custom-table-border"
                :height="180" 
                show-summary
                :summary-method="getSummary"
                :row-class-name="tabRowClass" 
                :row-key="getRowKey2"  
                ref="reffee" 
                
                v-loading="v_loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 251, 255, 0.8)"
                highlight-current-row>
                <el-table-column type="index" label="序号" width="55" fixed></el-table-column>
                <el-table-column v-for="(item,index ) in feeArr.filter(item=>item.thide=='N' && item.key!=='SEL')" :key="index"  
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    sortable
                    :min-width="item.width">
                    <template slot="header"><span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span></template>
                    <template  slot-scope="scope" >                      
                        <span v-if ="saveFlag" >
                            <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                            <span v-else v-text="scope.row[item.key]"></span>
                        </span>
                        <span v-else >                    
                            <el-input  v-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                            <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                            <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                        </span>
                    </template>
                </el-table-column> 
 
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="125">
                    <template slot-scope="scope">
                        <i class="iconfont icon-fuzhi" style="color:#409EFF;font-size:12px; "></i>
                        <el-link :disabled="addBool||saveFlag" @click="cpRec(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">复制行</span></el-link>
                        <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px; "></i>
                        <el-link :disabled="delBool||saveFlag" @click="feeDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:2px;">删除 </span></el-link>
                    </template>
                </el-table-column>                      
            </el-table> 
 
                <div class="one-toolbar">
                    <span class="spanRow"> 上传凭证附件</span> 
                </div>
                <div style="display:flex" >
                <Upload
                    ref="upload"
                    name="upfile"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="beforeImgFile"
                    :on-progress="handleProgress"
                    :on-success="successImgFile"
                    :with-credentials="true"                            
                    :format="['jpg','jpeg','png','tiff','bmp','gif' ]"
                    :max-size="10240"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    type="drag"
                    :action="uploadUrl"
                    style="display: inline-block;width:200px; ">                           
                    <div style="padding: 1px 0;width:200px;height:150px;">
                        <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                        <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                    </div>                                                       
                </Upload> 
                <div style="display:flex;margin-left:30px;"  >
                    <span v-for="(item,index) in imgData" :key="index">  
                        <el-image :disabled="saveFlag" fit="fill" :preview-src-list="[item.FILEPATH]" style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH"></el-image>
                        <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> 删除</el-link>
                            <!-- <el-link :underline="false" @click="imgPreview(item.FILEPATH)"><Icon type="ios-search" /> 预览</el-link> -->
                        </div>
                    </span>
                </div> 
            </div>
            </div>
            <div v-if="spFlag" style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button :disabled="prevFlag" type="text" icon="iconfont icon-shangyiye"  @click="prevRec" style="margin-right:20px;">上行记录</el-button>
                    <el-button :disabled="nextFlag" type="text" icon="iconfont icon-xiayiye1"  @click="nextRec" style="margin-right:20px; ">下行记录</el-button>
                    <span :style="stfgColor">
                        <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-left:40px;height:35px;vertical-align:middle"></i>
                    </span>
                    <el-button size="small" type="info" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:50px;margin-left:20px">取消</el-button>
                    <el-button size="small" :disabled="saveFlag?true:false" type="primary" icon="iconfont icon-baocun"  @click="saveRec('x')" style="margin-right:40px;">保存后退出</el-button>
                    <el-button size="small" :disabled="saveFlag?true:false" type="primary" icon="iconfont icon-baocun"  @click="saveRec('a')" style="margin-right:5px;">保存后新增</el-button>
                </span>
            </div>
            <div v-if="!spFlag" style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <span :style="stfgColor">
                        <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-left:40px;height:35px;vertical-align:middle"></i>
                    </span>
                    <el-button size="small" type="info" icon="iconfont icon-shanchu"  @click="modal_exit" style="margin-right:50px;margin-left:20px">取消</el-button>
                    <el-button size="small" :disabled="saveFlag?true:false" type="primary" icon="iconfont icon-baocun"  @click="saveRec('s')" style="margin-right:40px;">保存</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 凭证明细新增 -->
        <el-dialog   :visible.sync="dtlWin" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{dtlFlag==='create'?'明细新增':'明细编辑'}}</span>
            </div> 
            <Form :model="dtlRow" :label-width="120" ref="dtlForm"  label-position="right" inline  :rules="ruleValidate">  
                <span v-for="(item,index) in dtlArr" :key="index" >
                    <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                        <el-date-picker  type="date"  v-if="item.edcss==='date'" v-model="dtlRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                        <el-input @change="calcAmt"  v-enter-number  v-else-if="item.key==='QTY'" v-model="dtlRow[item.key]" ></el-input>   
                        <el-input-number @change="calcAmt" :precision="item.dotnum"  v-else-if="item.key==='PRC'" v-model="dtlRow[item.key]" style="width:100%"></el-input-number> 
                        <el-checkbox border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="dtlRow[item.key]" style="width:100%"></el-checkbox> 
                        <el-select  v-else-if="item.key==='UNIT'" v-model="dtlRow[item.key]"   style="width:100%">
                            <el-option v-for="(item,index) in unitArr " :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                        </el-select>
                        <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="dtlRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button size="small" type="info" icon="iconfont icon-shanchu"  @click="dtlWin=false" style="margin-right:50px;">取消</el-button>
                    <el-button size="small" type="primary" icon="iconfont icon-baocun"  @click="dtl_ok" style="margin-right:3px;">保存</el-button>
                </span>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="promptWin" v-dialogDrag width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="50px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-image src="assets/authorize/loading.gif" fit="fill" style="height:30px;background:#F96161" ></el-image>
        </el-dialog>
        <el-dialog :visible.sync="showViewer" width="800px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">预览</span>
            </div>
            <el-image fit="scale-down"  style=" margin:5px auto;height:500px;width:100% " :src="listurl"></el-image>
        </el-dialog>   
        <!-- 显示余额 -->
        <el-dialog :visible.sync="disWin" v-dialogDrag width="570px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">银行账户余额</span> 
            </div> 
            <span style="margin-left:5px;font-size:14px; color:red;font-weight:600">最近余额计算时间 : {{maxDttm}}</span>
            <div style="display:flex;line-height:40px;border-bottom:2px solid #409EFF">
                <div style="width:350px; ">银行账户名称</div>
                <div style="width:200px; ">账户实时余额</div>
            </div>
            <div style="display:flex;line-height:38px;border-bottom:1px solid #ccc" v-for="(item ,index) in cashArr" :key='index'>
                <div style="width:350px; ">{{item.ACCNM}}</div>
                <div style="width:200px; ">{{item.CURAMT}}</div>
            </div>
        </el-dialog> 
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <!-- 引用单据-->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="refWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">费用明细</span>
            </div> 
            <div style="border-bottom:2px solid #389;margin-top:-2px;background:white;min-width:1000px;width:100%;display:flex">
                <!-- <el-checkbox border size="small"  @change="selChg"  v-model="selAll" true-label="Y"  false-label="N"><span style="font-size:12px;margin-left:5px;color:#389">全选</span></el-checkbox> -->
                <div style="font-size:12px;font-weight:600;line-height:30px;">字段查询</div>
                <el-select v-model="selparam3"  placeholder="请选择列名" clearable size="small" style="width:190px;margin-left:5px; ">
                    <span v-for="item in feeArr" :key='item.key'>
                        <el-option v-if="item.thide=='N'" :label="item.title" :value="item.key"></el-option>
                    </span>
                </el-select>
                <el-select v-model="oper3"  size="small" style="width:110px;margin-bottom:3px;margin-left:2px; ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                    </span>
                </el-select>
                <el-input placeholder="请输入查询值"  v-model="txtparam3" size="small" style="width:260px;margin-left:2px;margin-top:3px; ">
                    <el-button slot="append" icon="el-icon-search" @click="qryRefData" style="color:#409eff"></el-button>
                </el-input>  
                <el-button @click="cfmSave" style="margin-left:15px" icon="iconfont icon-chenggong1" type="primary" size="mini">确定选择</el-button>  
            </div>
            <div style="height:83vh;overflow-y:auto">
                <el-table  :data="refData" 
                        border                            
                        disabled-hover
                        class="custom-table-border"
                        :cell-style="{padding:'2px'}"
                        style="overflow:auto;margin-top:1px;"
                        v-loading="v_load"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"
                        size="small"
                        :height="tabHeight" 
                        ref="refjoin" 
                        highlight-current-row>
                    <el-table-column type="index" width="60" label="序号"  ></el-table-column>  
                    <el-table-column  v-for="(item,index ) in feeArr.filter(item=>item.thide=='N')" :key="index" 
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        sortable
                        :min-width="item.width">
                        <template slot-scope="scope">
                            <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <span v-else >{{scope.row[item.key]}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 分页查询 -->
            <div style="display:flex; line-height:30px;align-items:center;height:35px;font-size:12px;padding-left:5px;margin-top:5px" >              
                <Page :total="dataCnt" :page-size="rowSize" show-total :current="curpage" @on-change="nextPage"></Page>
    
            </div>
        </el-dialog>
        <!-- 报表-->
        <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="repWin" width="340px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <div style="display:flex;  ">
                <div style="font-size:12px;width:100px;line-height:35px;color:red">资金账户</div>
                <el-select  v-model="v_cashno" style="width:100%" >
                    <span v-for="(item ,index) in cashArr" :key='index'>
                        <el-option :label="item.ACCNM" :value="item.IDSEQ" ></el-option>
                    </span>
                </el-select>
            </div>
            <div style="display:flex; margin-top:15px; ">
                <div style="font-size:12px;width:100px;line-height:35px">年份</div>
                <el-input placeholder="请输入年份：如 2024，也可为空"  type="number"  @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_year"  style="width:100%"  ></el-input>   
            </div>
            <div style="display:flex; margin-top:15px;margin-bottom:15px">
                <div style="font-size:12px;width:100px;line-height:35px">月份</div>
                <el-select  v-model="v_month" style="width:100%" >
                    <span v-for="(item ,index) in mthArr" :key='index'>
                        <el-option :label="item.CNAME" :value="item.CODE" ></el-option>
                    </span>
                </el-select>
            </div>
            <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:2px; ">
                <span style="float:right">
                    <el-button type="info" @click="repWin=false" size="small" style="margin-left:50px;" icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button   @click="repBtn" size="small" type="primary" style="margin-left:50px;" icon="iconfont icon-baocun"  > 确定 </el-button> 
                </span>
            </div> 
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repShow" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
    </div>
</template>

<script>
  import listItem from './inv_bank_two.vue'   
  import custSup from '../datamgt/cust_sup.vue'
  import subject from '../datamgt/inout_tmpl.vue'
  import { getTabColOrData,getBaseData } from '../../api/user'
  import {getDate} from '../../api/Select'
  export default {
    name: 'inv_bankday',
    components: {
        custSup,//往来单位
        subject,//科目
        listItem,
    },
    data() {
      return {
          actitem:'one',
        v_row:{},
        repShow:false,
        repUrl:'',
        repWin:false,
        v_cashno:'',
        v_year:'',
        v_month:'',
        v_load:false,
        expkeys:['0'],
        empArr:[],
        selAll:'N',
        refWin:false,
        refData:[],
        promptWin:false,
        dtlWin:false,
        showViewer:false,
        listurl:'',
        tagArr:[],
        inputVisible:false,
        inputValue:'',
        uploadData:{}, //上传数据
        unitArr:[],
        v_empno:'',
        v_empnm:'',
        prompt:'',
        addWin:false, //modal 
        corpWin:false,
        subWin:false,
        uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
        dtlRow:{},
        acArr:[],
        formCol:{}, //表格单行记录 model
        accData:[] , //树结构数据
        dtlData:[],
        oper:'like',
        selparam:'DTTM',
        txtparam:'',
        v_loading:false,    
        oper3:'like',
        selparam3:'',
        txtparam3:'',
        Accept: "jpg,jpeg,png,tiff,bmp,gif", //上传文件格式限制
        dtlFlag:'create',
        spFlag:true,
        bFlag:false,
        aFlag:false,
        v_acno:'',
        v_word:'',
        v_tag:'',
        v_bamt:'',
        defaultProps: {  //el-tree 默认字段属性
            children: 'children',
            id:'id',
            icon:'icon',
            parentid:'',
            label: 'label'
        },
        ruleValidate:{}, //校验规则
        loadWin:false,
        typeFlag: 'create',
        nodeLabel:this.$cookies.get('v_corpnm'),
        videoFlag:false,
        videoUploadPercent:0,
        v_orgnm:'',
        treeid :'0',
        dttm_:'',
        cashno:'',
        allData:[],
        tabData:[],
        tabArr:[],
        dtlArr:[],
        feeData:[],
        feeArr:[],
        saveFlag:false,
        v_url:'xuper_auth/getTableRecMany' , //api请求路径
        orgArr:[],
        addBool:false, //新增,为true时--禁止
        editBool:false, //编辑,为true时--禁止
        delBool:false, //删除 ,为true时--禁止
        cfmBool:false, //审核 ,为true时--禁止
        cancelBool:false, //作废 ,为true时--禁止 
        v_admin:this.$cookies.get('v_admin') ,//      
        v_username:this.$cookies.get('v_telno'), //api 请求用户
        
        v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
        dataCount:0,
        dataCnt:0,
        refAll:[],
        rowSize:100,
        goPage:'',
        maxDttm:'',
        prevFlag:false,
        nextFlag:false,
        payArr:[],
        notNull:[],
        cashArr:[],
 
        mthArr:[],
        certArr:[],
        delArr:[],
        dtlIndex:'',
        current:1,
        curpage:1,
        stfgColor:'',
        stfgCss:'',
        imgData:[],
        disWin:false,
        rowIndex:'-1',
        operArr:[],
        delFee:[],
        pageList: [ {
            value: 100,
            label: '100'
            }, {
            value: 500,
            label: '500'
            } ],
      }
    },
    created () {
        if(this.v_username){
            this.getData() //左边树
            this.getTabField() // 字段集
            this.getAccList(' and cashno=\''+this.cashno+'\' ')
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData(this.v_url,'corpid',this.v_corpid,'','','V_FEE_EMP','').then(res=>{
            this.orgArr =res.result
        })
        getBaseData(this.v_url,'corpid',this.v_corpid,'','','v_hr_emp','').then(res=>{
            this.empArr =res.result
        })
        getBaseData(this.v_url,'corpid',this.v_corpid,'','','V_AC_iotype','').then(res=>{
            this.acArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限 :frmid:94供应商资料ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','14445','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        }) 
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','14401','lstseq','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
        //资金账户选择
        getBaseData(this.v_url,'CORPID',this.v_corpid ,'','','v_account',' and stfg=\'Y\' order by sortby').then(res=>{
            this.cashArr =res.result
        })
 
        getBaseData(this.v_url,'','','','','v_mth','').then(res=>{
            this.mthArr =res.result
        })
        //凭证字
        getBaseData(this.v_url,'PARENTNO','4258','','','v_sys_base','').then(res=>{
            this.certArr =res.result
        })
        //常用单位
        getBaseData(this.v_url,'PARENTNO','14429','','','v_sys_base','').then(res=>{
            this.unitArr =res.result
        })
        //结算方式
        getBaseData(this.v_url,'PARENTNO','4252','','','v_sys_base','').then(res=>{
            this.payArr =res.result
        })
        this.getMaxDttm()
    },
    computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 90) + 'px';
            },
            tabHeight: function() {
                return (window.innerHeight - 163) + 'px';
            }, 
            sumHeight: function() {
                return (window.innerHeight - 192) + 'px';
            },
            tabWidth: function() {
                return (window.innerWidth - 100) + 'px';
            },
        },
    methods: {
        //复制行记录
        cpRec(row,index){
            let v_obj ={ IDNO:row['IDNO'],DTTM:row['DTTM'],EMPNM:row['EMPNM'],FEETYNM:row['FEETYNM'],DEPTNM:row['DEPTNM'],
                        ACNM:'',CRCY:row['CRCY'],REASON:row['REASON'], PAYMTH:row['PAYMTH'],CHKAMT:'', PAYTIME:row['PAYTIME'],PAYTYPE:row['PAYTYPE'],
                        RMK:row['RMK'],REFIDSEQ:row['REFIDSEQ'] ,REFLSTSEQ:row['REFLSTSEQ'],ISCP:'Y',LSTSEQ:''
                        }
            this.feeData.splice(index+1,0,v_obj)  //在其下方插入一行
        },
        itemClick(val){
            this.actitem =val     
        },
        getDtlSum(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =this.allData.map(item=>Number(item[column.property])) 
                if(column.property==='BAMT'||column.property==='DAMT'){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property])) 
                if(column.property==='CHKAMT' ){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.qryTabData()
        } ,
        repBtn(){   
            if (!this.v_cashno){
                this.promptWin =true
                this.prompt ='请选择资金账户'
            }else{
                this.repShow =true
                this.repWin =false
                this.repUrl =this.$store.state.repUrl+'inv_bankday.cpt'+'&p_corpid='+this.v_corpid+'&p_cashno='+this.v_cashno +'&p_year='+this.v_year+'&p_month='+this.v_month
            }
        },
        expExcel(){
            this.loadWin =true   
            //导出
            this.$axios({
                method: 'post',
                url:'xuper_auth/report/GenExcel',
                data: {p_idseq:'14445',p_lstseq:'1',p_json:JSON.stringify(this.allData),p_action:'银行日记账'},
                responseType:'blob' //关键，声明响应类型为二进制流
            }).then(response=>{ 
                // 从响应头解析后端设置的文件名
                // 创建Blob对象并触发下载  创建下载链接
                const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob)
                link.download = '银行日记账_'+getDate('full')+'.xls'
                link.click()
                URL.revokeObjectURL(link.href)
                this.loadWin =false
            }) 
        },
        modal_exit(){
            this.addWin =false  
            this.$emit('child-exit')
        },
        //确定选择 所关联记录
        cfmSave(){
            let arr =[]
            this.refData.forEach(item=>{
                if (item['SEL']=='Y'){
                    let obj ={}
                    let v_pkseq =item['IDSEQ']+'-'+item['LSTSEQ']
                    Object.assign(obj,item,{IDSEQ:'',LSTSEQ:'',REFIDSEQ:item['IDSEQ'],REFLSTSEQ:item['LSTSEQ']  })
                    let bool =true
                    //判断是否存在添加 
                    this.feeData.some(item=>{
                        if (item['REFIDSEQ']+'-'+item['REFLSTSEQ'] ==v_pkseq){
                            bool =false
                        }
                    })
                    if (bool){
                        arr.push(obj)
                    }
                }
            })
            if (arr.length >0){
                arr.forEach(item=>{
                    this.feeData.push(item)
                }) 
            }
            this.refWin=false
        },
        //关联单据
        addList(){
            this.refWin =true
            this.refData=[]
            this.selAll='N'
            this.v_load=true
            getTabColOrData(this.v_url,'V_FIN_FEEDTL','corpid',this.v_corpid).then((res) => {
                this.refAll =res.result
                this.initData()
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refjoin.doLayout()
                    this.v_load=false
                })
            })
        },
        qryRefData(){
            let cond_=''
            if (this.selparam3 && this.txtparam3){ //列1
                if (this.oper3==='like'){
                    cond_=cond_+' and '+this.selparam3+'  like  \'%' + this.txtparam3+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam3  +this.oper3+' \''+this.txtparam3+'\' '
                }
            }
            getTabColOrData(this.v_url,'V_FIN_FEEDTL','corpid',this.v_corpid,'','','','',cond_).then((res) => {
                this.refAll =res.result
                this.initData()
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refjoin.doLayout();
                })
            })
        },
 
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        showCalc(){
            this.disWin =true
        },
        //上一条、下一条
        prevRec(){
            if(this.rowIndex!=='-1'){
                this.rowIndex--
                this.nextFlag=false
                if (this.rowIndex<0){
                    this.rowIndex=0
                    this.prevFlag=true
                }
                this.rowClick(this.allData[this.rowIndex])
                if(this.allData[this.rowIndex].STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }
            }
        },
        nextRec(){
            if(this.rowIndex!=='-1'){
                this.rowIndex++
                this.prevFlag=false
                if (this.rowIndex>this.allData.length){
                    this.rowIndex=this.allData.length
                    this.nextFlag=true
                }
                this.rowClick(this.allData[this.rowIndex])
                if(this.allData[this.rowIndex].STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }
            }
        },
        //标签的赋予增加
        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus()
            })
        },
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.tagArr.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
        },
        tagClose(tag) {
            this.tagArr.splice(this.tagArr.indexOf(tag), 1);
        },
        //图片预览
        imgPreview(path){
            this.showViewer=true
            this.listurl=path
        },
        //图片删除，操作数组
        imgDel(item,index){
            this.$confirm('你确定要删除此图片吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:item['IDSEQ'],p_key2:'lstseq',p_value2:item['LSTSEQ'], p_table:'mat_img'},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        this.imgData.splice(index, 1);   
                        let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                        //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                        if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                            this.$axios({
                                method: 'post',
                                url: '/xuper_oss/ftpDelete',
                                data: {p_path:'/volume1'+v_path},
                            }).then(res=>{ 
                                console.log(res.result)
                            })
                        }
                    }else{
                        this.prompt=res.message
                        this.promptWin=true
                    }        
                })    
            }).catch(()=>{})
        },
         //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择 jpg,jpeg,png,tiff,bmp,gif 格式'
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出10M' 
        },
        //查询图片数据
        qryImgData(idseq){
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'filety','IMG').then((res) => {
                this.imgData=[]
                if (res){
                    this.imgData =res.result
                }
            })
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            } else{
                this.promptWin =true
                this.prompt =res.result
            }                     
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {  
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
  
        },
        //状态审核
        recSet(row,val,index){
            let stfg_ =val=='Y'?'审核':val=='N'?'弃审':'作废'
            this.$confirm('你确定要'+stfg_+'此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'FIN_BANK',p_cond:' set stfg=\''+val+'\'' },
                }).then(res=>{      
                    if(res.code =='200')  {           
  
                        if (val =='X'){
                            this.tabData.splice(index,1)
                        }else{
                            this.tabData.splice(index,1,Object.assign(row,{STFG:val}))
                        }
                    }else{
                        this.promptWin=true
                        this.prompt=res.message
                    }        
                }) 
                 
            }).catch(()=>{})
        },
        //刷新计算余额
        freshCalc(){
            this.$confirm('你确定要重新计算账户余额吗?' ,'提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.loadWin=true
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/calcDayCash',
                    data: {corpid:this.v_corpid,p_user:this.v_username,p_action:'BANK' },
                }).then(res=>{ 
                    if (res.code==='200'){
                        this.loadWin=false
                        this.qryTabData()
                        this.getMaxDttm()
                        getBaseData(this.v_url,'CORPID',this.v_corpid ,'','','v_account',' and stfg=\'Y\' order by sortby').then(res=>{
                            this.cashArr =res.result
                        })
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                        this.loadWin=false
                    }
                })
                // setInterval(()=>{this.loadWin=false},5000)
            }).catch(()=>{})
        },
        getMaxDttm(){
            this.$axios({    //select ${p_key2},max(gpno) gpno,count(1) cnt from ${p_table}
                method: 'post',
                url:'xuper_auth/getRecGroup',
                data: {p_key2:'corpid',p_key:'corpid',p_value:this.v_corpid,  p_table:'V_BANK_LOG' },
            }).then(res=>{ 
                if (res.code==='200'){
                    if (res.result.length>0)
                    this.maxDttm=res.result[0].GPNO
                }
            })
        },
        //查询凭证明细记录
        // getDtlData(idseq){
        //     getTabColOrData(this.v_url,'V_fin_bankdtl','idseq',idseq).then((res) => {
        //         this.dtlData=[]
        //         this.dtlData =res.result  
        //         this.$nextTick(()=>{
        //             this.$refs.refdtl.doLayout()
        //         })
        //     })
        // },
        //查询凭证费用明细
        getFeeData(idseq){
            this.v_loading =true
            getTabColOrData(this.v_url,'V_FIN_BANKFEE','idseq',idseq).then((res) => {
                this.feeData=[]
                this.feeData =res.result  
                this.$nextTick(()=>{
                    this.$refs.reffee.doLayout()
                    this.v_loading=false
                })
            })
        },
        //明细确认
        dtl_ok(){
            if (this.dtlFlag==='create'){
                this.dtlData.push(this.dtlRow) //新增
            }else{
                this.dtlData.splice(this.dtlIndex,1,this.dtlRow)  //替换
            }
            this.dtlWin=false
        },
        calcAmt(){
            this.dtlRow['AMT']=this.dtlRow['QTY']*this.dtlRow['PRC']
        },
        dtlAdd(){
            this.dtlRow={}
            this.dtlWin=true
            this.dtlFlag='create'
        },
        //往来单位选择
        clntSel(idseq,clntnm){
            this.formCol['ORGNO']=idseq
            this.formCol['ORGNM']=clntnm
            this.corpWin=false
        },
        supSel(idseq,supnm){
            this.formCol['ORGNO']=idseq
            this.formCol['ORGNM']=supnm
            this.corpWin=false
        },
        //人员选择
        empChg(val){
            this.empArr.some(item =>{
                if (item['IDNO']==val){
                    this.formCol['EMPNM']=item['EMPNM']
                }
            })
        },
        acChg(val){
            this.acArr.some(item =>{
                if (item['IDSEQ']==val){
                    this.formCol['ACNM']=item['ACNM']
                }
            })
        },
        orgChg(val){
            // this.formCol['DEPTNO']=''
            // this.formCol['BANKADDR']=''         
            this.orgArr.some(item=>{
                if(item['EMPNM']==val){
                    this.formCol['ORGNO']=item['IDNO']
                }
            })
        },
        //科目选择
        subOk(idseq,accnm){
            this.formCol['ACNO']=idseq
            this.formCol['ACNM']=accnm
            this.subWin=false
        },
        subChoose(){
            this.subWin=true
        },
        //往来单位选择
        orgChoose(){
            this.corpWin=true
        },
        wordChange(val){
            if(val==='4259' ||val==='4263'){ //收、现收
                Object.assign(this.formCol,{'DAMT':''})
                this.aFlag=true  
                this.bFlag=false 
            }else if(val==='4260'||val==='4264' ){ //付、现付
                Object.assign(this.formCol,{'BAMT':''})
                this.bFlag=true
                this.aFlag=false   
            }else{
               this.bFlag=false
               this.aFlag=false 
            }
        },
        //汇总为贷方
        sumDebit(){
            if(this.formCol['WORD']==='4259'||this.formCol['WORD']==='4263'){
                this.promptWin=true
                this.prompt='当前凭证字为收/现收,不能将明细合计设置为贷方金额'
            }else if (this.dtlData.length===0){
                this.promptWin=true
                this.prompt='明细记录为空时不能设置'
            }else{
                let v_sum=0
                for(let k=0 ;k<this.dtlData.length;k++){
                    v_sum=v_sum+ Number(this.dtlData[k]['AMT'])
                }    
                this.$confirm('是否将明细汇总金额:'+v_sum+'设置为贷方金额?','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    Object.assign(this.formCol,{DAMT:v_sum,BAMT:''})
                }).catch(()=>{})
            }
        },
        //汇总为借方
        sumPay(){
            if(this.formCol['WORD']==='4260'||this.formCol['WORD']==='4264'){
                this.promptWin=true
                this.prompt='当前凭证字为付/现付,不能将明细合计设置为借方金额'
            }else if (this.dtlData.length===0){
                this.promptWin=true
                this.prompt='明细记录为空时不能设置'
            }else{
                let v_sum=0
                for(let k=0 ;k<this.dtlData.length;k++){
                    v_sum=v_sum+ Number(this.dtlData[k]['AMT'])
                }    
                this.$confirm('是否将明细汇总金额:'+v_sum+'设置为借方金额?','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    Object.assign(this.formCol,{BAMT:v_sum,DAMT:''})
                }).catch(()=>{})
            }
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabArr.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                    }else{
                        v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                    }

                }
            })
            //this.getAccList( cond_+v_cond)
            this.getAccList(' and cashno=\''+this.cashno+'\' and dttm like \''+this.dttm_+'%\'' +cond_+v_cond)
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getRowKey2(row){
            return row.index
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
            if (row['ISCP'] =='Y'){
                return 'red-row';
            }
        },
        rowClick(row){
            if (row['STFG']==='Y')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFG']==='N')  { 
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'             
            }else{
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }
            if (row.TAG){
                this.tagArr =row.TAG.split(',')
            }else{
                this.tagArr=[]
            }
            this.formCol =JSON.parse(JSON.stringify(row))
            
        },
        editRec(row,index,val){
            if (row.REFDBSEQ){
                this.promptWin=true
                this.prompt='当前凭证为账户期初金额自动生成,请在资金账户管理中进行修改'
            }else{
                if(row.STFG==='Y'||val=='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }
                this.rowIndex=index
                this.addWin=true 
                this.typeFlag='edit'
                this.wordChange(row.WORD)
                this.delArr=[]
                //凭证明细
               // this.getDtlData(row.IDSEQ)
                this.getFeeData(row.IDSEQ) //费用明细
                //产品图片
                this.qryImgData(row.IDSEQ) 
            }
        },
        dtlEdit(row,index ){
            this.dtlRow =JSON.parse(JSON.stringify(row))
            this.dtlWin=true 
            this.dtlFlag='edit'
            this.dtlIndex=index
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt='请输入跳至页数'
            }
        },
        //日记账明细
        getAccList(cond){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+ ' order by dttm ',p_table:'V_FIN_bank'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.tabref.doLayout();
                })
            }) 
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        initData(){
            //产品明细
            this.dataCnt =this.refAll.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.refAll.length < this.rowSize){
                this.refData = this.refAll          
            }else{
                if (this.curpage >1){
                    this.nextPage(this.curpage)
                }else{
                    this.refData =this.refAll.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allData.slice(_start,_end);
        },
        nextPage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.curpage =index
            this.refData = this.refAll.slice(_start,_end);
        },
        //确定 保存
        saveRec(valStfg){
            let v_bool =true
            //发起保存请求   
            this.$refs['addForm'].validate((valid) => {
                if (valid){   
                    if(!this.formCol['ACNO']){
                        this.promptWin=true
                        this.prompt='收支类别不能为空'
                    }else{
                        if (valStfg=='s' && this.imgData.length==0){
                            v_bool =false
                        }else{
                            v_bool =true
                        }
                        if (v_bool ){
                            let v_title=''
 
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/getBaseData',
                                data: {p_key:'IDSEQ', p_value:this.formCol['CASHNO'],p_key2:'corpid', p_value2:this.v_corpid,p_cond:'',p_table:'V_AC_ACCOUNT'},
                            }).then(res=>{
                                let v_dttm=res.result[0].DTTM.substring(0,7)
                                var v_todttm=this.formCol['DTTM'].substring(0,7)
                                if (v_dttm<=v_todttm){ 
                                    let obj_=''
                                    if (this.tagArr.length>0){
                                        obj_=Object.assign(this.formCol,{CORPID:this.v_corpid,TAG:this.tagArr.join(',')})
                                    }else{
                                        obj_=Object.assign(this.formCol,{CORPID:this.v_corpid,TAG:''})
                                    }
                                    this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/formOneSave',
                                        data: {p_json:JSON.stringify(obj_), p_table:'FIN_bank',p_frmid:''},
                                    }).then(res=>{       
                                        if(res.code ==='200')  { 
                                            let v_idseq= res.idseq
                                            //明细保存
                                            this.$axios({   
                                                method: 'post',
                                                url:'xuper_auth/batDtlSave2',
                                                data: {p_json:JSON.stringify(this.dtlData), p_table:'fin_bankdtl',p_idseq:v_idseq, p_action:'S' },
                                            }).then(res=>{   
                                                if (res.code==='200'){
                                                    this.$message('单据已成功保存')
                                                    if (this.cashno){   
                                                        //this.getAccList(' and cashno=\''+this.cashno+'\' and dttm like \''+ v_todttm +'%\'')
                                                        this.qryTabData()
                                                        this.treeid=this.cashno+'-'+v_todttm
                                                    }else{
                                                        this.getAccList('') 
                                                    }    
                                                    this.getData()    
                                                    if (valStfg==='x'){  //保存退出
                                                        this.addWin =false     
                                                    }else if (valStfg==='s'){ //单据引用状态
                                                        this.addWin =false  
                                                        this.$emit('child-save',v_idseq)
                                                    }else{
                                                        this.$message('单据已成功保存')
                                                        this.addRec() //保存后即进入新增状态
                                                    }
                                                } else{
                                                    this.promptWin=true
                                                    this.prompt=res.result
                                                }    
                                            })
                                            //明细删除
                                            if (this.delArr.length>0 ) {
                                                this.$axios({   
                                                    method: 'post',
                                                    url:'xuper_auth/batDtlSave2',
                                                    data: {p_json:JSON.stringify(this.delArr), p_table:'fin_bankdtl',p_idseq:v_idseq, p_action:'D' },
                                                }).then(res=>{   
                                                    if (res.code!=='200'){
                                                        this.promptWin=true
                                                        this.prompt=res.result
                                                    }    
                                                })
                                            }
                                            //费用保存
                                            this.$axios({   
                                                method: 'post',
                                                url:'xuper_auth/batDtlSave2',
                                                data: {p_json:JSON.stringify(this.feeData), p_table:'fin_bankfee',p_idseq:v_idseq, p_action:'S' },
                                            }).then(res=>{ 
                                                if (this.delFee.length>0 ) {
                                                    this.$axios({   
                                                        method: 'post',
                                                        url:'xuper_auth/batDtlSave2',
                                                        data: {p_json:JSON.stringify(this.delFee), p_table:'fin_bankfee',p_idseq:v_idseq, p_action:'D' },
                                                    }) 
                                                }
                                            })
                                            //3、图片保存
                                            for(var k=0;k<this.imgData.length;k++){
                                                this.$axios({
                                                    method: 'post',
                                                    url:'xuper_auth/tableBodySave',
                                                    data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:v_idseq},
                                                })
                                            }   
                                        }else{
                                            this.prompt=res.result
                                            this.promptWin=true
                                        }        
                                    }) 
                                }else{
                                    this.promptWin=true
                                    this.prompt='发生日期不能小于资金账户的当前账期:'+v_dttm
                                }
                            }).catch(()=>{
                                this.promptWin=true
                                this.prompt='系统错误,请联系管理员' 
                            })
                            //}
                        }else{
                            this.prompt='请上传凭证图片'
                            this.promptWin=true
                        }
                    }
                }
            })
        } ,
        //新增
        addRec(){  
            this.$axios({ //取到最大IDNO +1
                method: 'post',
                url:'xuper_auth/getMaxNum',
                data: {p_key:'idno',p_value:'100',p_key2:'corpid',p_value2:this.v_corpid, p_table:'FIn_bank'},
            }).then(res=>{      
                if(res.code =='200')  {  
                    this.addWin =true
                    this.typeFlag ='create'
                    this.formCol ={IDSEQ:'',BAMT:this.v_bamt,IDNO:res.result, STFG:'N','DTTM':getDate('full'),EMPNM:this.v_empnm,
                         CASHNO:this.cashno,ACNO:this.v_acno,WORD:this.v_word,ORGNM:this.v_orgnm,TAG:this.v_tag,EMPNO:this.v_empno} 
                    this.delArr=[]   
                    this.dtlData=[]
                    if (this.spFlag){
                        this.feeData=[]
                    }
                    this.saveFlag=false
                    this.delFee=[]
                    this.imgData =[]
                    this.stfgCss='icon-weishenhe3'
                }else{
                    this.prompt=res.result
                    this.promptWin=true
                }        
            })               
        },
 
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        //节点点击
        handleNodeClick(data){
            this.nodeLabel=data.label;          
            this.treeid =data.id
            let index=this.treeid.indexOf('-')
            if(index>-1){
                this.dttm_=this.treeid.substring(index+1)
            }else{
                this.dttm_=data.id
            }
            this.cashno=data.icon
            this.getAccList(' and cashno=\''+this.cashno+'\' and dttm like \''+this.dttm_+'%\'')
        },
        dtlDel(row,index){
            this.delArr.push(row)
            this.dtlData.splice(index,1)
        },
        feeDel(row,index){
            this.delFee.push(row)
            this.feeData.splice(index,1)
        },
        //删除记录
        delRec(row){
            if (row.REFDBSEQ){
                this.promptWin=true
                this.prompt='当前凭证为账户期初金额自动生成,请在资金账户管理中进行维护'
            }else{
                this.$confirm('你确定要删除此行记录吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    //发起删除请求
                    var vm=this;
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/delTabRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'FIN_bank'},
                    }).then(res=>{      
                        if(res.code =='200')  {           
                            vm.getData()   
                            vm.getAccList(' and cashno=\''+this.cashno+'\' and dttm like \''+this.dttm_+'%\'')  
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
                }).catch(()=>{})
            }
        },
        // 获取 树形控件数据
        getData() {   
            var vm=this;
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData',
                data: {p_table:'V_BANK_MENU',p_cond:' and (corpid=\'-1\' or corpid=\''+this.v_corpid+'\') order by sortby,code'}
            }).then(function(res){ 
                if (res.code==='200'){                 
                    vm.accData =res.result;  
                    vm.$nextTick(()=>{ //必须要放在nexttick里，要不然还未渲染上
                        vm.$refs.eltree.setCurrentKey(vm.treeid)
                    })
                } else{
                    vm.promptWin=true
                    vm.prompt=res.result
                }            
            })                            
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','14445','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','14445','lstseq','2','','',' order by sortby').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','14445','lstseq','3','','',' order by sortby').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.feeArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        notnull:res.result[k].NOTNULL, 
                    })
                }
            })
        }
    }
  }
</script>
<style scoped lang="less">
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .input-new-tag {
        width: 120px;
        margin-left: 10px;
        vertical-align: bottom;
    }
    .button-new-tag {
        margin-right: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .item-width  {
        width: 32%;
        color:red !important;
    } 
 
    .nodeLabel{
        font-size:12px;
        font-weight:500;
        padding-left:10px;
        color: black;
    }
    .nodeRoot{
        width:20px;
        font-size:14px;
        font-weight:600;
    }  
    .top{
        padding: 10px;
        background: rgba(0, 153, 229, .7);
        color: #fff;
        text-align: center;
        border-radius: 2px;
    } 
     .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }       
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-table .red-row  {
        color: red;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{  //用于表格中checkbox disabled时为蓝色
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
    .yellow .el-input__inner {
        background-color: #f5d9b1;    //橙色
    }
    .el-tag  {
        margin-left: 10px;
    }
</style>
